import { Component, Prop, Emit, Watch, Vue } from 'vue-property-decorator'

@Component({
  components: {
  }
})
export default class ModalBase extends Vue {
  @Prop({ default: false }) isActive!: Boolean
  @Prop({ default: '' }) size!: String
  @Prop({ default: '20px 15px' }) padding!: String
  @Prop({ default: true }) isBtnClose!: Boolean
  @Prop({ default: true }) isOverleyClose!: Boolean

  @Watch('isActive')
  onIsActive (val) {
    val ? this.$emit('show') : this.$emit('hide')
  }

  _modalClose (type = '') {
    if (!type || (type === 'overley' && this.isOverleyClose)) {
      this.$emit('modal-close')
    }
  }
}
